import { useRef, useState, useEffect } from "react";
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import { Spinner, Button, Alert } from 'react-bootstrap';
import { Base64 } from 'js-base64';
import Tick from '../../src/images/tick.png'
import Fail from '../../src/images/fail.png'
import './Gameprofile.css';
import './IDProofing.css';


Base64.extendUint8Array();

function Airplaneprofile() {
    const title = 'goID ID Proofing Portal';
    let { aid } = useParams();
    const [givenname, setgivenname] = useState(null);
    const [surname, setsurname] = useState(null);
    const [dateOfBirth, setdateOfBirth] = useState(null);
    const [photo, setphoto] = useState(null);
    let [issuerAuth, setissuerAuth] = useState(false);
    let [docType, setdocType] = useState("");
    let [deviceAuth, setdeviceAuth] = useState(false);
    let [liveness, setLiveness] = useState(false);
    let [faceMatch, setFaceMatch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [cardType, setCardType] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [show, setShow] = useState(false);
    const [applink, setApplink] = useState("");
    const [isAppOpened, setisAppOpened] = useState(false);
    useEffect(() => {
        getVerificationResult();
        let cardType = localStorage.getItem('CardType');
        setCardType(cardType);
        if (cardType === 1) {
            setdocType("Mobile Driving License");
        } else if (cardType === 3) {
            setdocType("Mobile ID");
        }
        else { 
            setdocType("Digital Travel Credential");
        }
    }, []);

    async function getVerificationResult() {
        try {

            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };

            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/result/" + aid,
                headers: headers,
                responseType: 'application/json'
            });
            
            if (response.status == 200) {
                let dddd = JSON.parse(response.data);
                if (dddd.image.image == undefined || dddd.image.image == null) {
                    setphoto('NO_PHOTO');
                }else {
                    setphoto(dddd.image.image);
                }
              
                setissuerAuth(dddd.image.issuerAuth);
                setLiveness(dddd.liveness);
                setFaceMatch(dddd.facematch);
            }else {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
                setIsLoading(false);
                setphoto('NO_PHOTO');
            }
        } catch (e) {
            setphoto('NO_PHOTO');
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }


    async function getIssuanceDeeplink(cardType) {
        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/ocr/sed/" + aid,
                headers: headers,
                responseType: 'application/json'
            });

            if (response.status == 200) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                let applinkd = jsonData.redirectUrl;
                setApplink(applinkd);
                window.location.replace(applinkd);
            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }
        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else {
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }


    return (
        < >

            <main className="mainbg">
                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                                    <h5 className="headTilte">
                                                        Verification summary
                                                    </h5>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {issuerAuth == true ? (
                                            <p><img className="px-2" src={Tick}></img> Authenticity</p>
                                        ) : <p></p>
                                        }

                                        {faceMatch == true ? (<p><img className="px-2" src={Tick}></img> Face Match</p>
                                        ) : (<p><img className="px-2" src={Fail}></img> Face Match</p>)}

                                        {liveness == true ? (<p><img className="px-2" src={Tick}></img> Selfie Liveness​ </p>
                                        ) : (<p><img className="px-2" src={Fail}></img> Selfie Liveness​ </p>)}
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {photo == null ?
                                            <div class="row">
                                                <div class="loader-container">
                                                    <div class="loading-text">Loading<span class="dots"></span></div>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {(photo != 'NO_PHOTO' && photo.length > 0) ?
                                                    <div class="row">
                                                        <div class="col imgbox">
                                                            <img class="center-fit rounded-6"
                                                                style={{ width: 320, height: 300 }}
                                                                src={`data:image/png;base64,${photo}`}
                                                                alt=""></img>
                                                        </div>
                                                    </div>
                                                    : ""
                                                }
                                            </>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                       
                                        {cardType === "2" ? (
                                            <div>
                                                <hr />
                                                <Button className="btn btn-primary btn-lg px-4 gap-3"
                                                    disabled={isLoading}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setIsLoading(true);
                                                        getIssuanceDeeplink();
                                                    }}
                                                >
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                                                    {faceMatch === true ? <span className="px-2">Apply for photoID with CHV</span> :
                                                        <span className="px-2">Apply for photoID without CHV</span>}
                                                </Button>
                                            </div>
                                        ) : ("")}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </main>

             <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default Airplaneprofile;